<template>
  <div>
    <PageTitle title="Audit Log" />
    <v-container fluid>
      <v-card>
        <v-card-title>Changes</v-card-title>
        <v-container fluid>
          <v-data-table
            :headers="headers"
            :items="rows"
            :loading="loading"
            item-key="id"
            :items-per-page="15"
          >
            <template v-slot:item.changes="{ item }">
              <div v-if="!item.changes || !item.changes.length">—</div>
              <div v-for="change in item.changes" :key="change.field">
                {{ change.field }}: {{ change.from }} → {{ change.to }}
              </div>
            </template>
            <template v-slot:no-data>
              <div class="py-4 text-center">No audit records yet</div>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  data: () => ({
    rows: [],
    loading: false,
    headers: [
      { text: "Date and time", value: "date", width: "16%" },
      { text: "Who", value: "causer_name", width: "14%" },
      { text: "Action", value: "description", width: "10%" },
      { text: "Record", value: "subject_type", width: "16%" },
      { text: "Record id", value: "subject_id", width: "10%" },
      { text: "Changes", value: "changes" },
    ],
  }),
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      axios
        .get("audit-logs")
        .then((res) => {
          this.rows = Array.isArray(res.data) ? res.data : [];
          this.loading = false;
        })
        .catch(() => {
          this.rows = [];
          this.loading = false;
        });
    },
  },
};
</script>
